import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { of, Subject, Subscription, timer } from 'rxjs';
import { takeUntil, catchError, filter, switchMap } from 'rxjs/operators';
import { HhsgSharedUserProfile } from '../../../models/user-profile.model';
import {
  HhsgSharedConfigService,
  HhsgSharedNotificationService,
  HhsgSharedUserService,
} from '../../../services';
import { ErrorUtil } from '../../../utilities/error.util';

@Component({
  selector: 'huron-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  @Input() user: HhsgSharedUserProfile;
  private _unsubscribe$ = new Subject<void>();

  applicationAbbreviation: string;
  notificationCountSubscription: Subscription;
  notificationSubscription: Subscription;
  notificationCount: number = 0;

  constructor(
    public configService: HhsgSharedConfigService,
    protected _userService: HhsgSharedUserService,
    public notificationService: HhsgSharedNotificationService
  ) {}

  ngOnInit(): void {
    this.setupNotificationService();
  }

  ngOnDestroy(): void {
    if (this.notificationCountSubscription) {
      this.notificationCountSubscription.unsubscribe();
    }
    if (this.notificationSubscription) {
      this.notificationSubscription.unsubscribe();
    }
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  private setupNotificationService() {
    this.applicationAbbreviation =
      this.configService.appSettings.applicationAbbreviation;

    this.notificationCountSubscription =
      this.notificationService.notificationCount$
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe((notificationCount: number) => {
          this.notificationCount = notificationCount;
        });

    // A recursive function that calls itself every one min.
    // The timer and check to see if any new notifictaion has been received.
    // This will add dely (in miliseconds) to prevent params undefined issue of user id and application id for the first time.
    this.notificationSubscription = timer(60000, 60000)
      .pipe(
        switchMap(() => {
          if (this.user && this.user.userId)
            return this.notificationService
              .getNotificationCount(
                this.user.userId,
                this.applicationAbbreviation
              )
              .pipe(
                catchError(err => {
                  ErrorUtil.logError(err);
                  return of(undefined);
                })
              );
          else return of(undefined);
        }),
        filter(data => data !== undefined)
      )
      .subscribe(notificationCount => {
        this.notificationCount = notificationCount;
      });
  }
}
